import { t } from 'i18next';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { appDanger, appSuccess } from '../app_alerts/slice';
import { getOrganizationSlug } from '../organizations/selectors';
import { getEdgeConnections, getEdgeOfferingConnections, patchExistingEdgeConnection, postNewEdgeConnections, removeEdgeConnection } from './data';
import { errorReceiveCreateEdgeConnection, errorReceiveEdgeConnections, errorReceiveEdgeOfferingConnections, errorReceiveModifyEdgeConnection, errorReceiveRemoveEdgeConnection, failedReceiveCreateEdgeConnection, failedReceiveEdgeConnections, failedReceiveEdgeOfferingConnections, failedReceiveModifyEdgeConnection, failedReceiveRemoveEdgeConnection, receiveCreateEdgeConnection, receiveEdgeConnections, receiveEdgeOfferingConnections, receiveModifyEdgeConnection, receiveRemoveEdgeConnection } from './slice';
export function* requestCreateEdgeConnection(action) {
    try {
        const { consumerAPI, edgeOfferingId, edgeConnectionPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(postNewEdgeConnections, organization, edgeOfferingId, edgeConnectionPayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveCreateEdgeConnection());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveCreateEdgeConnection(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_EDGE_CONNECTION', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveCreateEdgeConnection());
                yield put(appDanger(t('ERROR_REQUEST_CREATE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveCreateEdgeConnection(response.data));
                yield put(appSuccess(t('SUCCESS_REQUEST_CREATE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_CREATE_EDGE_CONNECTION', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveCreateEdgeConnection());
    }
}
export function* requestEdgeConnections(action) {
    try {
        const { consumerAPI } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(getEdgeConnections, organization, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveEdgeConnections());
            }
            else if (data) {
                yield put(receiveEdgeConnections(data));
            }
            else {
                throw new Error(t('ERROR_REQUEST_EDGE_CONNECTIONS', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveEdgeConnections());
            }
            else if (response && response.status === 200) {
                yield put(receiveEdgeConnections(response.data));
            }
            else {
                throw new Error(t('ERROR_REQUEST_EDGE_CONNECTIONS', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeConnections());
    }
}
export function* requestEdgeOfferingConnections(action) {
    try {
        const { consumerAPI, edgeOfferingId, targetOrganization } = action.payload;
        const response = yield call(getEdgeOfferingConnections, targetOrganization, edgeOfferingId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveEdgeOfferingConnections());
            }
            else if (data) {
                yield put(receiveEdgeOfferingConnections(data));
            }
            else {
                throw new Error(t('ERROR_REQUEST_EDGE_OFFERING_CONNECTIONS', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveEdgeOfferingConnections());
            }
            else if (response && response.status === 200) {
                yield put(receiveEdgeOfferingConnections(response.data));
            }
            else {
                throw new Error(t('ERROR_REQUEST_EDGE_OFFERING_CONNECTIONS', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveEdgeOfferingConnections());
    }
}
export function* requestModifyEdgeConnection(action) {
    try {
        const { consumerAPI, edgeConnectionId, edgeConnectionPayload } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(patchExistingEdgeConnection, organization, edgeConnectionId, edgeConnectionPayload, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveModifyEdgeConnection());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveModifyEdgeConnection(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_EDGE_CONNECTION', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 200) {
                yield put(errorReceiveModifyEdgeConnection());
                yield put(appDanger(t('ERROR_REQUEST_MODIFY_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 200) {
                yield put(receiveModifyEdgeConnection(response.data));
                yield put(appSuccess(t('SUCCESS_REQUEST_MODIFY_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_MODIFY_EDGE_CONNECTION', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveModifyEdgeConnection());
    }
}
export function* requestRemoveEdgeConnection(action) {
    try {
        const { consumerAPI, edgeConnectionId } = action.payload;
        const organization = yield select(getOrganizationSlug);
        const response = yield call(removeEdgeConnection, organization, edgeConnectionId, consumerAPI);
        if (!consumerAPI) {
            const { data, error } = response;
            if (error) {
                yield put(errorReceiveRemoveEdgeConnection());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else if (data) {
                yield put(receiveRemoveEdgeConnection(data));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_EDGE_CONNECTION', {
                    ns: 'Common'
                }));
            }
        }
        else {
            if (response && response.status !== 204) {
                yield put(errorReceiveRemoveEdgeConnection());
                yield put(appDanger(t('ERROR_REQUEST_REMOVE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else if (response && response.status === 204) {
                yield put(receiveRemoveEdgeConnection(edgeConnectionId));
                yield put(appSuccess(t('SUCCESS_REQUEST_REMOVE_EDGE_CONNECTION', {
                    ns: 'Common'
                })));
            }
            else {
                throw new Error(t('FAILED_REQUEST_REMOVE_EDGE_CONNECTION', {
                    ns: 'Common'
                }));
            }
        }
    }
    catch (e) {
        yield put(failedReceiveRemoveEdgeConnection());
    }
}
export function* watchRequestCreateEdgeConnection() {
    yield takeLatest('edgeConnections/requestCreateEdgeConnection', requestCreateEdgeConnection);
}
export function* watchRequestModifyEdgeConnection() {
    yield takeLatest('edgeConnections/requestModifyEdgeConnection', requestModifyEdgeConnection);
}
export function* watchRequestRemoveEdgeConnection() {
    yield takeLatest('edgeConnections/requestRemoveEdgeConnection', requestRemoveEdgeConnection);
}
export function* watchRequestEdgeConnections() {
    yield takeLatest('edgeConnections/requestEdgeConnections', requestEdgeConnections);
}
export function* watchRequestEdgeOfferingConnections() {
    yield takeLatest('edgeConnections/requestEdgeOfferingConnections', requestEdgeOfferingConnections);
}
